import { extractProductGroups } from '../StringUtils.js';

/**
 * Extract stacklineSkus from product tags in content
 */
const extractProductSkus = (content) => {
    const regex = /<product stacklineSku="([^"]+)">/g;
    const productSkus = [];
    let match;
    while ((match = regex.exec(content)) !== null) {
        productSkus.push(match[1]);
    }
    return productSkus;
};
/**
 * Process text and replace product_group tags with placeholders
 * that won't be interpreted as markdown
 */
const processProductGroupTags = (text) => {
    let result = "";
    let currentPos = 0;
    let groupIndex = 0;
    while (currentPos < text.length) {
        // Check for product_group tag
        const groupStart = text.indexOf("<product_group>", currentPos);
        if (groupStart === -1) {
            // No more groups, add rest of text
            result += text.substring(currentPos);
            break;
        }
        // Add text before group tag
        result += text.substring(currentPos, groupStart);
        // Check if we have a complete group tag
        const groupEnd = text.indexOf("</product_group>", groupStart);
        if (groupEnd === -1) {
            // Incomplete group tag, stop processing to avoid showing partial tags
            break;
        }
        // Replace complete group with placeholder using a format that won't be interpreted as markdown
        // Using |||PRODUCT_GROUP_N||| instead of __PRODUCT_GROUP_N__ to avoid markdown bold interpretation
        result += `|||PRODUCT_GROUP_${groupIndex}|||`;
        groupIndex++;
        // Move past the closing tag
        currentPos = groupEnd + 16; // "</product_group>".length
    }
    return result;
};
/**
 * Extract product groups with their SKUs organized by group index
 */
const extractStreamingProductGroups = (text) => {
    const groups = extractProductGroups(text);
    const streamingGroups = new Map();
    groups.forEach((group, index) => {
        const skus = group.products.map((p) => p.stacklineSku);
        streamingGroups.set(index, skus);
    });
    return streamingGroups;
};

export { extractProductSkus, extractStreamingProductGroups, processProductGroupTags };
//# sourceMappingURL=productGroupParser.js.map
